import { GlobalErrorHandler } from './interceptors/global-error-handler';
import { BaseComponent } from './base.component';
import { AuthService } from './services/auth.service';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { HttpCustomInterceptor } from './interceptors/http-custom.interceptor';
import {
  APP_INITIALIZER,
  ErrorHandler,
  NgModule,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpRequestLoaderInterceptor } from './interceptors/loader-spinner-interceptor';
import { ErrorHandlerInterceptor } from './interceptors/error-interceptor.service';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        BaseComponent,
    ],
    providers: [
        AuthService,
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpRequestLoaderInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpCustomInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorHandlerInterceptor,
            multi: true,
        },
        // Below initializer should not be used going forward as the refresh page, initialization and 
        // authentication check is getting handled in AuthGuard.
        // {
        //   provide: APP_INITIALIZER,
        //   useFactory: initAuthentication,
        //   multi: true,
        //   deps: [AuthService, Router, TranslateService, ActivatedRoute],
        // },
        // {
        //   provide: LOCALE_ID,
        //   useFactory: (translate: TranslateService) => {
        //     configureLocale(translate);
        //     return translate.getDefaultLang();
        //   },
        //   deps: [TranslateService],
        // },
        {
            provide: APP_INITIALIZER, useFactory: setLocale,
            deps: [TranslateService],
            multi: true,
        },
    ],
})
export class CoreModule { }

export function setLocale(translateService: TranslateService) {
  let localId: string = 'en';
  return (): void => {
    const defaultLocal = 'en';
    const sessionStorageLang = localStorage.getItem('lang');
    if (sessionStorageLang?.includes('en') || sessionStorageLang?.includes('fr')) {
      translateService.setDefaultLang(
        sessionStorageLang?.includes('en') ? 'en' : 'fr'
      );
    } else if (localId.includes('en') || localId.includes('fr')) {
      translateService.setDefaultLang(localId?.includes('en') ? 'en' : 'fr');
    } else {
      translateService.setDefaultLang(defaultLocal);
    }
    translateService.use(translateService.getDefaultLang());
  };
}

export function configureLocale(translateService: TranslateService) {
  let localId: string = 'en';
  var userLang = navigator.language;
  const defaultLocal = userLang ?? 'en';
  const sessionStorageLang = localStorage.getItem('lang');
  if (
    sessionStorageLang?.includes('en') ||
    sessionStorageLang?.includes('fr')
  ) {
    translateService.setDefaultLang(
      sessionStorageLang?.includes('en') ? 'en' : 'fr'
    );
  } else if (localId.includes('en') || localId.includes('fr')) {
    translateService.setDefaultLang(localId?.includes('en') ? 'en' : 'fr');
  } else {

    translateService.setDefaultLang(defaultLocal);
  }

  localStorage.setItem('lang', translateService.getDefaultLang());
  translateService.use(translateService.getDefaultLang());

}

/**
 * @deprecated Do not use this function as all the authentication logic is getting handled in AuthGuard.
 * 
 */
export function initAuthentication(
  authService: AuthService,
  router: Router,
  translateService: TranslateService
) {
  return () => {
    if (localStorage.getItem('token')) {
      // verify token
      return lastValueFrom(authService.loadProfileWithPermission())
        .then((configuration: any) => {
          // translateService.setDefaultLang(authService.getUser().language); // read user preferred language
          // translateService.use(authService.getUser().language); // read user preferred language
          //   localStorage.setItem('lang', authService.getUser().language ?? 'en'); // read user preferred language
          // router.navigate(['/private']);
          return configuration;
        })
        .catch((error: any) => {
          console.error(error);
        });
    } else {
      return;
    }
  };
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/translations/', '.json');
}
